import rest from "@/restUtils";
import constants from '@/constants';

const subscriptionPath = '/subscription';
const promocodePath = '/promocode';

export default {
    namespace: true,
    state: {
        currentSubscription: null,
        showTrialWindow: false
    },

    actions: {
        async getTrialDays(context) {
            try {
                return await rest.doGet(`${subscriptionPath}/trial-days`);
            } catch (error) {
                return 7;
            }
        },

        async getWallet(context) {
            try {
                return await rest.doGet(`${subscriptionPath}/wallet`);
            } catch (error) {
            }
        },

        async getPrice(context, promocode) {
            try {
                let result = await rest.doPost(`${subscriptionPath}/price`, {promocode});
                return {
                    pro: Number(result.proAmount) / 100
                };
            } catch (error) {
                alert(error.response.data.message);
            }
        },

        async getCurrentSubscription({commit}) {
            try {
                let subscription = await rest.doGet(subscriptionPath);
                commit('setCurrentSubscription', subscription);
                return subscription;
            } catch (error) {
                // У пользователя нет текущей подписки, игнорируем
            }
        },

        async createPaymentRequest({commit}, payload) {
            try {
                let paymentEntry = await rest.doPost(`${subscriptionPath}/create-payment`,
                        {
                            tariff: payload.tariff,
                            promocode: payload.promocode
                        });
                return paymentEntry;
            } catch (error) {
                alert(error.response.data.message);
            }
        },

        async generatePromocode(context) {
            try {
                let promocode = await rest.doPost(promocodePath);
                return promocode;
            } catch (error) {
                alert(error.response.data.message);
            }
        },

        setShowTrialWindow({commit}, visible) {
            commit('setShowTrialWindow', !!visible);
        }
    },

    mutations: {
        setCurrentSubscription: (state, payload) => state.currentSubscription = payload,
        setShowTrialWindow: (state, payload) => state.showTrialWindow = payload,
    },

    getters: {
        currentSubscription: (state) => Object.freeze(state.currentSubscription),
        proTariff: (state) => !!state.currentSubscription
                && state.currentSubscription.tariff === constants.tariff.PRO,
        showTrialWindow:  (state) => state.showTrialWindow
    }
}